<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div class="col-sm-12">
    <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
      <div class="col-6 q-cards">
        <label class="card card-list pt-2 text-center d-inline-block pull-right" for="NewService">
          <img src="{{ns_src}}" height="100px">
          <div></div>
          <label for="NewService">New Service</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="NewService" value='New Service'
              [(ngModel)]="hgService.ns" name="service" (change)="getService($event)" />
            <label class="custom-control-label" for="NewService"></label>
          </div>
        </label>
      </div>
      <div class="col-6 q-cards">
        <label class="card card-list pt-2 text-center d-inline-block pull-left" for="SwitchingProviders">
          <img src="{{sp_src}}" height="100px">
          <div></div>
          <label for="SwitchingProviders">Switching Providers</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="SwitchingProviders" value='Switching Providers'
              [(ngModel)]="hgService.sp" name="service" (change)="getService($event)" />
            <label class="custom-control-label" for="SwitchingProviders"></label>
          </div>
        </label>
      </div>
    </div>
  </div>
  <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': isChecked}"
    (click)="next();">Next</button>
</div>
<div class="container mobileview px-0 mb-4" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0 mt-2">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="d-flex mt-2">
      <div class="col-6 pl-0 box-shadow-none">
        <label class="card card-list text-center d-inline-block" for="NewService" style="min-height: 156px;">
          <img src="{{ns_src}}" width="60%">
          <label for="NewService">New Service</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input type='checkbox' class="custom-control-input" id="NewService_mob" value='New Service'
              [(ngModel)]="hgService.ns" name="service" (change)="getService($event);" />
            <label class="custom-control-label" for="NewService"></label>
          </div>
        </label>
      </div>
      <div class="col-6 pr-0 box-shadow-none">
        <label class="card card-list text-center d-inline-block" for="SwitchingProviders" style="min-height: 156px;">
          <img src="{{sp_src}}" width="60%">
          <label for="SwitchingProviders">Switching Providers</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input type='checkbox' class="custom-control-input" id="SwitchingProviders_mob" value='Switching Providers'
              [(ngModel)]="hgService.sp" name="service" (change)="getService($event);" />
            <label class="custom-control-label" for="SwitchingProviders"></label>
          </div>
        </label>
      </div>
    </div>
    <div class="text-center" style="width:100% !important;">
      <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    </div>
    <div style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box mt-2">
        <h1 class="ansMob" *ngIf="service ==='Switching Providers'">I want to Switch Providers</h1>
        <h1 class="ansMob" *ngIf="service !='Switching Providers'">I want to establish {{service}}</h1>
      </div>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
            <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div>
</div>